var app = angular.module('app-cart-service', ['ngCookies']);

app.service('cartService', ['$http', '$window', '$q', '$cookies', function ($http, $window, $q, $cookies) {
    var factory = {};
    //factory._corsActive = '';
    factory._masterDomain = $window.masterDomain;
    factory._cart = {};
    factory._cartSummary = {};

    //factory.CorsActive = function () {
    //    ConsoleLog('cors 1a: start');
    //    var def = $q.defer();
    //    //GDG / 20180111 / uitgezet omdat het niet werkte op windows 8 met IE10.
    //    //if (($cookies.get('corsActive') == undefined || $cookies.get('corsActive').length == 0) && (masterDomain == '' || masterDomain.indexOf('www.giant-bicycles.com') > -1)) {
    //    //    //in dit geval is cors niet nodig, daarom cookie direct zetten
    //    //    $cookies.put('corsActive', 'true');
    //    //    log('cors 2a: cors not necessary working on domain ' + masterDomain);
    //    //}
    //    if ($cookies.get('corsActive') == undefined || $cookies.get('corsActive').length == 0) {
    //        ConsoleLog('cors 2b: corsActive cookie undefined or length = 0');

    //        $http({
    //            method: 'GET',
    //            url: masterDomain + '/' + $window.culture + '/shop/set-cors-cookie?r=' + Math.random(),
    //            cache: false,
    //            withCredentials: true
    //        }).then(function (res) {
    //            ConsoleLog('cors 3: return of shop/set-cors-cookie: ' + res.data);

    //            $http({
    //                method: 'GET',
    //                url: masterDomain + '/' + $window.culture + '/shop/get-cors-cookie?r=' + Math.random(),
    //                cache: false,
    //                withCredentials: true
    //            }).then(function (res) {
    //                ConsoleLog('cors 4: return of shop/get-cors-cookie: ' + res.data);

    //                factory._corsActive = res.data;
    //                //$cookies.CorsActive = res.data;
    //                $cookies.put('corsActive', res.data);
    //                def.resolve();
    //            }).catch(function (e) {
    //                // handle errors in processing or in error.
    //                if (window.isDeveloperMachine == true) {
    //                    ConsoleLog(e);
    //                    //alert('cors 4 failed: cannot GET cors cookie');
    //                    //alert(JSON.stringify(e));
    //                }
    //            });
    //        }).catch(function (e) {
    //            // handle errors in processing or in error.
    //            if (window.isDeveloperMachine == true) {
    //                ConsoleLog(e);
    //                //alert('cors 3 failed: cannot SET cors cookie');
    //                //alert(JSON.stringify(e));
    //            }
    //        });
    //    } else {
    //        ConsoleLog('cors 2c: corsActive cookie exists: ' + $cookies.get('corsActive'));

    //        factory._corsActive = ($cookies.get('corsActive') == 'true');
    //        def.resolve();
    //    }
    //    //log('cors 1b: end');
    //    return def.promise;
    //}

    factory.MasterDomain = function () {
        var def = $q.defer();
        //factory.CorsActive().then(function () {
        //if ((store != undefined && store.length > 0) || factory._corsActive == true) {
        if (store != undefined && store.length > 0) {
            factory._masterDomain = $window.masterDomain;
        } else {
            factory._masterDomain = ''; //private mode
        }
        def.resolve();
        //});
        return def.promise;
        //return $window.masterDomain;
    }

    factory.getCartSummary = function () {
        ConsoleLog('getCartSummary 1: start');

        var def = $q.defer();
        //if ((masterDomain != '' && $window.location.hostname.indexOf('www.giant-bicycles.com') == -1) || (store != undefined && store.length > 0) || $cookies.get('cart-' + $window.cultureFull) != undefined) {
        if ($cookies.get('cart-' + $window.cultureFull) != undefined || (store != undefined && store.length > 0)) {
            factory.MasterDomain().then(function () {
                var url = factory._masterDomain + '/' + $window.culture + '/shop/getcart?expanded=false' + '&r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : '') + ('&divisionCode=' + $window.divisionCode);

                ConsoleLog('getCartSummary 2: url = ' + url);

                $http({
                    method: 'GET',
                    url: url,
                    cache: false,
                    withCredentials: true
                }).then(function (res) {

                    ConsoleLog('getCartSummary 3: cart data received');

                    angular.copy(res.data, factory._cartSummary);
                    def.resolve();
                    $('.summary-popup').css("display", "block");
                });
            });
        }
        return def.promise;
    }

    factory.getCart = function (initiator) {
        var def = $q.defer();
        factory.MasterDomain().then(function () {
            var url = factory._masterDomain + '/' + $window.culture + '/shop/getcart?expanded=true&divisionCode=' + $window.divisionCode + '&initiator=' + initiator;

            $http({
                method: 'GET',
                url: url + '&r=' + Math.random() + ($window.store != undefined && $window.store.length > 0 ? '&store=' + $window.store : ''),
                cache: false,
                withCredentials: true
            }).then(function (res) {
                angular.copy(res.data, factory._cart);
                def.resolve();
            });
        });
        return def.promise;
    }


    function ConsoleLog(message) {
        if (window.isDeveloperMachine == true && 1 == 2) {
            log(message);
        }
    }

    return factory;
}]);